import FileItem from './FileItem';

export default FileItem;
